import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useLazyGetUserProfile = (userId) => {
  return useQuery(
    ["getUserProfileDescription", userId],
    () => axiosClient.get(`/UserProfile/GetUserProfileDescription?userId=${userId}`),
    { enabled: false } 
  );
};

export default useLazyGetUserProfile;